import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressBookDto, BankDto, CommunitiesDto, LandTitleDto, LgaDto, StateDto, TitleDto, IncidentDto } from '@cradua/data';

@Component({
  selector: 'cradua-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent implements OnInit {

  @Input() titles: TitleDto[];
  @Input() banks: BankDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() communities: CommunitiesDto[];
  @Input() selectedLandTitle: LandTitleDto[];
  @Input() addressBooks: AddressBookDto[];
  @Input() isLoadingAddressBook: boolean;
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() emitSaveAddressBook = new EventEmitter<any>();
  @Output() emitClearAddressBook = new EventEmitter<any>();
  selectedIncidentId: IncidentDto;
  filterCommunities: CommunitiesDto[];
  filterLgas: LgaDto[];
  addressBookForm: FormGroup;
  searchedAddressBook: AddressBookDto[];
  modalEvent
  task = '';
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.createAddressBookForm();
    console.log('modal Event ', this.modalEvent)
  }

  createAddressBookForm() {
    this.addressBookForm = this.fb.group({
      TitleId: ['', Validators.required],
      Name: [''],
      Address: [''],
      PhoneNo: [''],
      Email: [''],
      StateId: [''],
      LgaId: [''],
      CommunityId: [''],
      BankId: [''],
      AccountName: [''],
      AccountNo: [''],
      Remarks: [''],
      VendorId: [''],
      id: null,
    })
  }

  onSearch(query) {
// this.emitAddressBook.emit(query);
    query ?
this.searchedAddressBook = this.addressBooks.filter(item => item.Name && item.Name.toLowerCase().includes(query.toLowerCase())) :
   this.searchedAddressBook = [];
  }

  onViewTask(value: AddressBookDto) {
    this.task = 'create';
    this.addressBookForm.patchValue(value);
    this.onFilterLga(value.StateId);
    this.onFilterCommunity(value.LgaId);
  }

  onTask(value) {
  // console.log('task ', value);
  if(value === 'create') {
    this.addressBookForm.reset();
    this.emitClearAddressBook.emit(value);
  }
    this.task = value;
  }

  protected filterById = <T>(id: string, lookupId: string) =>
  (fieldName: T) => fieldName[lookupId] === id;


  onFilterLga(id: string) {
    this.filterLgas = this.lgas.filter(
      this.filterById<LgaDto>(id, "StateId"),
    );
  }

  onFilterCommunity(id: string) {
    this.filterCommunities = this.communities.filter(
      this.filterById<CommunitiesDto>(id, "LgaId"),
    );
  }

  onSubmit(value: AddressBookDto) {
    this.emitSaveAddressBook.emit(value);
    this.addressBookForm.reset();
    this.task = '';
  }

}
